import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import {
    SMS_LIST_TABLE_TITLE_WIDTHS,
    SMS_LIST_TABLE_TITLES,
    SMS_LIST_TABLE_TITLE_SORT,
} from "src/helpers/Constants";
import Pagination from "src/components/Pagination";
import { ListType, OperationType, SMSListTableSortType } from "src/helpers/Enums";

const SMSListTable = (props) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [sortedList, setSortedList] = useState(props.list)

    useEffect(() => {
        if (props.list?.length > 6) {
            setSortedList(props.list?.slice((currentPage - 1) * 11, (currentPage * 11)))
            setTotalPages(Math.ceil(props.list?.length / 11))
        } else {
            setSortedList(props.list)
        }
    }, [props.list, currentPage])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className={ "w-full flex flex-col justify-between h-full" }>
            <div className={ "flex flex-col gap-3" }>
                <TableHeader titles={ SMS_LIST_TABLE_TITLES } widths={ SMS_LIST_TABLE_TITLE_WIDTHS }
                             sort={ SMS_LIST_TABLE_TITLE_SORT } sortedList={ sortedList }
                             sortType={ SMSListTableSortType }
                             setSortedList={ setSortedList }/>
                <div className="TableWrapper">
                    <table className="Table">
                        <tbody>
                        { sortedList?.map((item, index) => (
                            <tr key={ index } className="border-b h-[60px] hover:bg-[#F6F6F9]">
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: SMS_LIST_TABLE_TITLE_WIDTHS[0]} }>
                                    <div className={ "flex gap-3 items-center" }>
                                        <div className={ item.is_active ? "ActiveBox":"InactiveBox"}>{ item.is_active ? "Active" : "Inactive" }</div>
                                        <div className={"flex flex-col gap-1"}>
                                            <div>{ item.name }</div>
                                            {item.from_name &&
                                                <div className={"ListsFromNameLine"}>
                                                    <img alt={ "Logo" } src={ "/media/icons/fromName.svg" }
                                                         className={ "w-3 h-3" }/>
                                                    <div>{ item.from_name }</div>
                                                </div>
                                            }
                                            </div>
                                    </div>
                                </td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: SMS_LIST_TABLE_TITLE_WIDTHS[1]} }>{ item.slot }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: SMS_LIST_TABLE_TITLE_WIDTHS[2]} }>{ item.strategy_id?.name }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: SMS_LIST_TABLE_TITLE_WIDTHS[3]} }>
                                    <div className={ "flex gap-[6px]" }>
                                        { item.tag_ids?.map((tag) =>
                                            <div className={ "SMSEmailTableTag" }>{ tag.name }</div>
                                        ) }
                                    </div>
                                </td>
                                <td className="py-3 px-4 flex justify-center items-center">
                                    <button className="StrategyEditButton"
                                            onClick={ () => props.handleOpenNewList(OperationType.UPDATE, item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/editIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                    </button>
                                    <button className="StrategyDeleteButton"
                                            onClick={ () => props.handleOpenDeleteStrategy(ListType.SMS, item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                    </button>
                                </td>
                            </tr>
                        )) }
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={ currentPage } totalPages={ totalPages } onPageChange={ handlePageChange }/>
        </div>
    )
}

export default injectIntl(SMSListTable);
